/**
* @file Container component for dynamically inject columns in a relation grid.
* @author Tom Verschoore de la Houssaije
*/
import { ComponentFactoryResolver, OnInit, Injector, ViewContainerRef } from '@angular/core';
import { ColumnProvider } from '../../column-provider';
import { ComponentRegistry } from '../../../core/component-registry';
/**
 * This class is used to insert columns, of a specific type, into a template by configuration.
 */
var ColumnContainerComponent = /** @class */ (function () {
    /**
     * Constructs a ColumnContainerComponent
     */
    function ColumnContainerComponent(containerRef, factoryResolver) {
        this.containerRef = containerRef;
        this.factoryResolver = factoryResolver;
        /** Gets or sets the field configuration used in this container. */
        this.field = undefined;
        /** Gets or sets the entity instance shown by this column container. */
        this.entity = undefined;
    }
    /**
     * Is called directly after the creation of this component
     */
    ColumnContainerComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.field === undefined) {
            throw new Error('Field undefined.');
        }
        if (this.field.editor === undefined) {
            this.field.editor = 'string';
        }
        var editor = ComponentRegistry.getComponent('column', this.field.editor);
        var componentFactory = this.factoryResolver.resolveComponentFactory(editor);
        // https://stackoverflow.com/questions/45585606/staticinjector-vs-reflectiveinjector-in-angular
        var injector = Injector.create([
            {
                provide: ColumnProvider,
                useFactory: function () {
                    return new ColumnProvider(_this);
                },
                deps: []
            }
        ]);
        // ReflectiveInjector is deprecated #3479
        // const self = this;
        // const providers = ReflectiveInjector.resolve([{
        //     provide: ColumnProvider,
        //     useFactory: () => {
        //         return new ColumnProvider(self);
        //     }
        // }]);
        // const injector = ReflectiveInjector.fromResolvedProviders(providers, self.containerRef.parentInjector);
        this.containerRef.createComponent(componentFactory, 0, injector, []);
    };
    return ColumnContainerComponent;
}());
export { ColumnContainerComponent };
